/**
 * @file: initial-url.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { isDebugEnabled } from '@euler/functions/debug';
import { makeDebug } from '@euler/utils';

let initialPath: string | undefined = undefined;
let initialUrl: string | null = null;

const debug = makeDebug('initial-url', isDebugEnabled('linking'));

export function getInitialPath() {
  return initialPath;
}

export function getInitialUrlSearchParams() {
  if (!initialPath) {
    return null;
  }
  return new URLSearchParams(initialPath.split('?')[1]);
}

export function setInitialPath(path: string) {
  initialPath = path;
  debug('initial path: ', path);
}

export function updateInitialUrl(url: string | null) {
  initialUrl = url;
}

export function getInitialUrl() {
  return initialUrl;
}
